import { useMemo } from 'react';
import { selectValues } from '@icp/form-renderer-core';
import { get } from 'lodash-es';
import { useStore } from '../store';
import useDependencies from './useDependencies';
import { useCurrentData } from '../currentDataCtx';

export default function useDisplayValue(id, valueField, notUseIdToResolveValue) {
  const store = useStore();
  const formData = selectValues(store.getState());
  const currentData = useCurrentData();

  const ids = useMemo(() => {
    if (currentData) {
      return [];
    }

    if (valueField) {
      return valueField;
    }

    if (!notUseIdToResolveValue && id) {
      return id;
    }
    return null;
  }, [currentData, valueField, notUseIdToResolveValue, id]);

  useDependencies(ids);

  const data = currentData || formData || {};

  // valueField support keyPath
  if (valueField !== undefined && valueField !== null) {
    return get(data, valueField);
  }

  if (!notUseIdToResolveValue && id !== undefined && id !== null) {
    return data[id];
  }

  return undefined;
}
